import axios from 'axios'
import auth from '@/auth/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

api.interceptors.request.use((config) => {
  if (auth.isLogged()) {
    config.headers.Authorization = `Bearer ${auth.getTokenLogged()}`
  }
  return config
})

function parseMaybeJson (value) {
  return typeof value === 'string' ? JSON.parse(value) : (value || [])
}

function assertResult (response) {
  const result = response && response.data ? response.data.result : null
  if (result !== 'OK' && result !== true) {
    throw new Error((response && response.data && response.data.message) || 'Operación no completada')
  }
}

export default {
  async getPeople (companyId) {
    const [contactsResponse, partnersResponse, legalResponse, otherRelationshipsResponse] = await Promise.all([
      api.get('company/getContacts', { params: { company_id: companyId } }),
      api.get('company/getPartners', { params: { company_id: companyId } }),
      api.get('company/getLegalRepresentatives', { params: { company_id: companyId } }),
      api.get('company/getOtherRelationships', { params: { company_id: companyId } })
    ])

    return {
      contacts: parseMaybeJson(contactsResponse.data.contacts),
      partners: parseMaybeJson(partnersResponse.data.partners),
      legalRepresentatives: parseMaybeJson(legalResponse.data.legalRepresentatives),
      otherRelationships: parseMaybeJson(otherRelationshipsResponse.data.otherRelationships)
    }
  },

  async getContact (contactId) {
    const response = await api.get('company/getContact', { params: { contact_id: contactId } })
    return response.data.contact
  },

  async createContact (payload) {
    const response = await api.post('company/createContact', { contact: payload })
    assertResult(response)
    return response.data.contact || payload
  },

  async updateContact (payload) {
    try {
      const response = await api.post('company/updateContact', { contact: payload })
      assertResult(response)
      return response.data.contact || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createContact', { contact: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.contact || payload
    }
  },

  async deleteContact (contactId) {
    const response = await api.post('company/deleteContact', { contact: { id: contactId } })
    assertResult(response)
    return true
  },

  async getLegalRepresentative (legalRepresentativeId) {
    const response = await api.get('company/getLegalRepresentative', { params: { legal_representative_id: legalRepresentativeId } })
    return response.data.legalRepresentative
  },

  async createLegalRepresentative (payload) {
    const response = await api.post('company/createLegalRepresentative', { legalRepresentative: payload })
    assertResult(response)
    return response.data.legalRepresentative || payload
  },

  async updateLegalRepresentative (payload) {
    try {
      const response = await api.post('company/updateLegalRepresentative', { legalRepresentative: payload })
      assertResult(response)
      return response.data.legalRepresentative || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createLegalRepresentative', { legalRepresentative: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.legalRepresentative || payload
    }
  },

  async deleteLegalRepresentative (legalRepresentativeId) {
    const response = await api.post('company/deleteLegalRepresentative', { legalRepresentative: { id: legalRepresentativeId } })
    assertResult(response)
    return true
  },

  async getPartner (partnerId) {
    const response = await api.get('company/getPartner', { params: { partner_id: partnerId } })
    return response.data.partner
  },

  async createPartner (payload) {
    const response = await api.post('company/createPartner', { partner: payload })
    assertResult(response)
    return response.data.partner || payload
  },

  async updatePartner (payload) {
    try {
      const response = await api.post('company/updatePartner', { partner: payload })
      assertResult(response)
      return response.data.partner || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createPartner', { partner: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.partner || payload
    }
  },

  async deletePartner (partnerId) {
    const response = await api.post('company/deletePartner', { partner: { id: partnerId } })
    assertResult(response)
    return true
  },

  async getOtherRelationship (otherRelationshipId) {
    const response = await api.get('company/getOtherRelationship', { params: { other_relationship_id: otherRelationshipId } })
    return response.data.otherRelationship
  },

  async createOtherRelationship (payload) {
    const response = await api.post('company/createOtherRelationship', { otherRelationship: payload })
    assertResult(response)
    return response.data.otherRelationship || payload
  },

  async updateOtherRelationship (payload) {
    try {
      const response = await api.post('company/updateOtherRelationship', { otherRelationship: payload })
      assertResult(response)
      return response.data.otherRelationship || payload
    } catch (error) {
      const fallbackResponse = await api.post('company/createOtherRelationship', { otherRelationship: payload })
      assertResult(fallbackResponse)
      return fallbackResponse.data.otherRelationship || payload
    }
  },

  async deleteOtherRelationship (otherRelationshipId) {
    const response = await api.post('company/deleteOtherRelationship', { otherRelationship: { id: otherRelationshipId } })
    assertResult(response)
    return true
  }
}



